import React, { useEffect, useState } from 'react';
import classes from './css/ColorPicker.module.css';
import BackButton from '../../main/BackButton';
import axios from '../../../axios-backend';
import Line from '../../main/Line';
import { useNavigate, useLocation } from "react-router-dom";

const SizePicker = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [list, setList] = useState([]);

    const state = location.state || {};
    const { type, areaAmount, gender } = state;

    useEffect(() => {
        if (!location.state) {
            navigate('/');
            return;
        }

        if (type && gender !== undefined) {
            // ✅ Normalize gender to numeric for backend compatibility
            let normalizedGender = gender;

            if (gender === "female" || gender === "women" || gender === 0 || gender === "0") {
                normalizedGender = 0;
            } else if (gender === "male" || gender === "men" || gender === 1 || gender === "1") {
                normalizedGender = 1;
            } else if (gender === "unisex" || gender === 2 || gender === "2") {
                normalizedGender = 2;
            }

            axios.get(`/sizes-by-type`, { params: { tid: type, gender: normalizedGender } })
                .then(res => {
                    const data = res.data;
                    if (data.status === 200) {
                        if (!data.list || data.list.length === 0) {
                            alert('sorry, no product');
                            navigate(-1);
                        } else {
                            setList(data.list);
                        }
                    }
                })
                .catch(err => {
                    console.error("Error fetching sizes:", err);
                });
        }
    }, [type, gender, navigate, location.state]);

    if (!location.state) return null;

    const addLines = () => {
        const temp = [];
        for (let i = 0; i < 10 - list.length; i++) {
            temp.push(<Line key={i} type="bottom-line" />);
        }
        return temp;
    };

    // 👇 function to navigate when a line is clicked
    const handleLineClick = (size) => {
        navigate("/products/shopproduct", {
            state: { areaAmount, type, gender, size },
        });
    };

    return (
        <>
            <BackButton />
            <Line className={classes.centerText} type="bottom-line">
                pick your size
            </Line>
            {list.map((e, index) => (
                <Line
                    key={index}
                    className={`${classes.centerText} ${classes.basicLine}`}
                    type="bottom-line"
                    onClick={() => handleLineClick(e.size)} // ✅ full line clickable
                >
                    {e.size}
                </Line>
            ))}
            <Line
                type="bottom-line"
                className={`${classes.centerText} ${classes.basicLine}`}
                onClick={() =>
                    navigate("/products/productsizeguide", {
                        state: { areaAmount, type, gender },
                    })
                }
            >
                Find your size
            </Line>
            {list.length < 10 && addLines()}
        </>
    );
};

export default SizePicker;
